import { ITranslation } from "@/translations";

/**
 * The codes the backend records for a client (Kund:in), one per channel they acted through
 * (AuditActor.Client*UserCode) — never their login name, which is their e-mail address. All of them are
 * the client, so they render as the same actor label.
 */
const CLIENT_USER_CODES = [
  "client-portal-user",
  "client-upload-link",
  "client-1b-form-link",
  "client-registration-link",
  "client-password-reset-link",
];

/** Backend fallback for versions without a resolvable application action (UserConstants.UnknownUser). */
const UNKNOWN_USER_CODE = "Unknown";

/**
 * Service account every scheduled job runs under (BackgroundJobDefaults.UserCode). It is a machine
 * identifier meant for the audit trail, so it is labelled rather than shown to a SUL-Mitarbeiter:in.
 */
const BACKGROUND_JOB_USER_CODE = "background-job";

/** Service account of the RegistrationAPI (ApiKeyDefaults.ConsumerId); its writes are system actions too. */
const REGISTRATION_API_USER_CODE = "anmeldung-api";

/** Service account of the SMS gateway webhook (WebSmsInboundDefaults.ConsumerId). */
const WEBSMS_INBOUND_USER_CODE = "websms-inbound";

const SYSTEM_USER_CODES = [BACKGROUND_JOB_USER_CODE, REGISTRATION_API_USER_CODE, WEBSMS_INBOUND_USER_CODE];

/**
 * Identity of the login-time sync that writes a counselor's FSW-Portal data
 * (AuditActor.LoginSync).
 */
const FSW_PORTAL_USER_CODE = "fsw-portal";

/**
 * Renders a short code (counselor code or volunteer username) for display; external portal actors,
 * automated jobs, the FSW-Portal sync and unknown users get fixed labels instead.
 */
export function formatUserCode(userCode: string | null | undefined, t: ITranslation): string {
  if (!userCode || userCode === UNKNOWN_USER_CODE) {
    return t("changeHistory.actor.unknown");
  }

  if (SYSTEM_USER_CODES.includes(userCode)) {
    return t("changeHistory.actor.system");
  }

  if (userCode === FSW_PORTAL_USER_CODE) {
    return t("changeHistory.actor.fswPortal");
  }

  if (CLIENT_USER_CODES.includes(userCode)) {
    return t("changeHistory.actor.portal");
  }

  return userCode;
}

export default formatUserCode;
